import { useState, useEffect } from 'react';
import { certificateService } from 'PlatForms/SelfLMS/Services/Certificate/CertificateService';
import { toast } from 'react-toastify';

const useCertificates = (initialPage = 1, initialPageSize = 6) => {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [pageNumber, setPageNumber] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [totalCertificates, setTotalCertificates] = useState(0);

  const fetchCertificates = async (page = pageNumber, size = pageSize) => {
    try {
      setLoading(true);
      setError(null);

      const data = await certificateService.getLearnerCertificates(page, size, true);

      console.log("Fetched certificates:", data);

      // Assuming API returns { items: [...], totalCount: number }
      setCertificates(data.items || []);
      setTotalCertificates(data.totalCount || 0);

    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to fetch certificates';
      setError(errorMessage);
      setCertificates([]);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCertificates();
  }, [pageNumber, pageSize]);

  const refetch = () => fetchCertificates();

  return {
    certificates,
    loading,
    error,
    pageNumber,
    pageSize,
    totalCertificates,
    setPageNumber,
    setPageSize,
    refetch
  };
};

export default useCertificates;
